import React from 'react'

import { ContainerModal, ModalBackground } from './styles'

type ModalProps = {
    content: JSX.Element
    handleClose: React.Dispatch<React.SetStateAction<boolean>>
}

export function CustomModal({ content, handleClose }: ModalProps) {
    return (
        <ModalBackground onClick={() => handleClose(false)}>
            <ContainerModal>{content}</ContainerModal>
        </ModalBackground>
    )
}
